import React from 'react'
import Construction from '../components/animations/Construction'

export default function Notify(props) {


  return (
    <Construction />
  )
}
